import { ALERT, CLOSE } from './constants';

export function alert(payload) {
  return {
    type: ALERT,
    payload
  };
}

export function close() {
  return {
    type: CLOSE
  };
}
